import {
  createCatalogEndpoint,
  createCrudEndpoints,
  createNestedCrudEndpoints,
} from '@/core/utils'
import {
  TCoil,
  TPurchaseOrder,
  TPurchaseOrderDetail,
  TReception,
  TReceptionDetail,
} from '.'
import { DataWithPagination, TBaseHistoryActions } from '@/core/types'
import { TWarehouse } from '../warehouses'
import api from '@/core/config/axios'
import { MaybeRef } from 'vue'
import { TLocations } from '../locations'

export type TReceptions = DataWithPagination<TReception>
export type TReceptionDetails = DataWithPagination<TReceptionDetail>
export type TPurchaseOrderDetails = DataWithPagination<TPurchaseOrderDetail>
export type TCoils = TCoil[]
export const serviceConfig = {
  model: 'receipts',
  version: 'v1',
  details: {
    model: 'details',
    version: 'v1',
  },
  purchaseOrderDetails: {
    model: 'details',
    version: 'v1',
  },
  coils: {
    model: 'coils',
    version: 'v1',
  },
  catalogs: {
    purchaseOrders: {
      model: 'purchase-orders',
      version: 'v1',
    },
    warehouses: {
      model: 'warehouses',
      version: 'v1',
    },
    locations: {
      model: 'locations',
      version: 'v1',
    },
  },
}

const { purchaseOrders, warehouses, locations } = serviceConfig.catalogs
const { model: modelDetail, version: versionDetail } = serviceConfig.details
const { model: modelOCDetail, version: versionOCDetail } =
  serviceConfig.purchaseOrderDetails

const moduleServiceHandlers = {
  ...createCrudEndpoints<TReceptions, TReception>(
    serviceConfig.model,
    serviceConfig.version,
  ),
  loadHistoryActions: async (payload: {
    id?: MaybeRef<number | string>
  }): Promise<Partial<TBaseHistoryActions>[]> =>
    api
      .get(
        `${serviceConfig.version ?? ''}/${serviceConfig.model}/${
          payload.id
        }/history-actions`,
      )
      .then((response) => response.data),
}
const moduleServiceCoilHandlers = {
  ...createCrudEndpoints<TCoils, TCoil>(
    serviceConfig.coils.model,
    serviceConfig.coils.version,
  ),
  loadCoils: async (payload: {
    parentId?: MaybeRef<number | string>
    detailId?: MaybeRef<number | string>
  }): Promise<Partial<TCoil>[]> =>
    api
      .get(
        `${serviceConfig.version ?? ''}/${serviceConfig.model}/${
          payload.parentId
        }/${serviceConfig.details.model}/${payload.detailId}/coils`,
      )
      .then((response) => response.data),
}

const moduleDetailServiceHandlers = createNestedCrudEndpoints<
  TReceptionDetail[],
  TReceptionDetail
>(serviceConfig.model, modelDetail, versionDetail)

const ocDetailsHandlers = createNestedCrudEndpoints<
  TPurchaseOrderDetail[],
  TPurchaseOrderDetail
>(purchaseOrders.model, modelOCDetail, versionOCDetail)

const ocCatalogServiceHandlers = createCatalogEndpoint<TPurchaseOrder[]>(
  purchaseOrders.model,
  purchaseOrders.version,
)

const warehouseCatalogServiceHandlers = createCatalogEndpoint<TWarehouse[]>(
  warehouses.model,
  warehouses.version,
)

const locationsCatalog = createCatalogEndpoint<TLocations[]>(
  locations.model,
  locations.version,
)

const catalogServiceHandlers = {
  ocCatalogServiceHandlers,
  ocDetailsHandlers,
  warehouseCatalogServiceHandlers,
  locationsCatalog,
}

export {
  moduleServiceHandlers,
  moduleServiceCoilHandlers,
  moduleDetailServiceHandlers,
  catalogServiceHandlers,
}
